import { render, staticRenderFns } from "./ProductsSliderSection.vue?vue&type=template&id=600e222c&scoped=true&"
import script from "./ProductsSliderSection.vue?vue&type=script&lang=js&"
export * from "./ProductsSliderSection.vue?vue&type=script&lang=js&"
import style0 from "./ProductsSliderSection.vue?vue&type=style&index=0&id=600e222c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600e222c",
  null
  
)

export default component.exports